<template>
  <div>
    <div id="modalProductos" class="modal">
      <div class="modal-contenido rounded-xl p-1">
        <div
          class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 justify-items-end"
        >
          <button type="button" class="col-start-6 end text-xl mx-2 p-1">
            <a class="font-bold" href="#">X</a>
          </button>
        </div>
        <div class="w-full">
          <h4
            class="bg-gray-100 mx-9 mb-1 text-2xl shadow-xl text-black text-center mt-1 rounded divide-y divide-red-500"
          >
            Productos
            <hr color="black" size="4" />
          </h4>
        </div>
        <!--<div
          class="border rounded-xl w-80 border-solid border-t-4 border-l-4 border-r-4 border- shadow-2xl"
        >-->
        <div class="">
          <div class="justify-center mt-2">
            <div
              class="px-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5"
            >
              <div class="col-span-1 mx-7">
                <label
                  class="block uppercase mt-1 tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Referencia
                </label>

                <select
                  v-model.number="referenciaproducto"
                  @click="mostrar()"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="referenciaa.idreferencia"
                    :key="referenciaa.idreferencia"
                    v-for="referenciaa of referencias"
                  >
                    <button class="font-bold">
                      
                        {{referenciaa.codigoreferencia}} {{': '}}
                        
                      {{ referenciaa.nombrereferencia }}
                    </button>
                  </option>
                </select>
              </div>

              <div class="col-span-1 mx-5">
                <label
                  class="block mx-2 uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Codigo
                </label>

                <input
                  v-model="codigoproducto"
                  v-on:keyup="mostrar()"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                  id=""
                  type="text"
                  placeholder="Codi... "
                />
              </div>
              <div class="col-span-1 mx-5">
                <label
                  class="block mx-2 uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Nombre
                </label>

                <input
                  v-model="nombreproducto"
                  v-on:keyup="mostrar()"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                  id=""
                  type="text"
                  placeholder="Nom... "
                />
              </div>
               <div class="col-span-1 mx-5">
                <label
                  class="block mx-2 uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  valor de venta
                </label>

                <input
                  v-model.number="valorventa"
                  v-on:keyup="mostrar()"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                  id=""
                  type="number"
                  placeholder="valor de venta "
                />
              </div>
              <div class="col-span-1  mx-5">
                <label
                  class="block mx-2 uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Disponible
                </label>

                <input
                  v-model.number="disponibleproducto"
                  v-on:keyup="mostrar()"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                  id=""
                  type="number"
                  placeholder="disponible"
                />
              </div>
              <div class="col-span-1 mx-5 mt-3">
                <label
                  class="block mx-2 uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Reserva
                </label>

                <input
                  v-model.number="reservaproducto"
                  v-on:keyup="mostrar()"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                  id=""
                  type="number"
                  placeholder="reser..."
                />
              </div>
              <div class="col-span-1 mx-5 mt-3">
                <label
                  class="block mx-2 uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Costo
                </label>

                <input
                  v-model.number="costoproducto"
                  v-on:keyup="mostrar()"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                  id=""
                  type="number"
                  placeholder="costo..."
                />
              </div>
              <div class="col-span-1 mx-5 mt-3">
                <label
                  class="block  mx-2 uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Iva
                </label>

                <input
                  v-model.number="ivaproducto"
                  v-on:keyup="mostrar()"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                  id=""
                  type="number"
                  placeholder="iva..."
                />
              </div>
              <div class="col-span-1 mx-5 mt-3">
                <label
                  class="block mx-2 uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Foto
                </label>

                <input
                  v-model="foto"
                  v-on:keyup="mostrar()"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
   
                  type="text"
                  placeholder="foto..."
                />
              </div>
              <!-- <div class="col-span-1 mx-5 mt-3">
                <label
                  class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Usuario
                </label>

                <input
                  v-model="idusuario"
                  v-on:keyup="mostrar()"
                  class="appearance-none w-full mx-2 w-80 border-b-2 border-black shadow-xl block col-span-3 bg-gray-lighter text-grey-darker rounded py-1"
                  id=""
                  type="text"
                  placeholder="gen..."
                />
              </div>-->
              <div class="col-span-1 mx-7 mt-3">
                <label
                  class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
                >
                  Linea
                </label>
                <select
                  @click="mostrar()"
                  v-model.number="linea"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                >
                  <option disabled value="">Seleccione una Linea</option>
                  <option
                    v-bind:value="lineaa.idlinea"
                    :key="lineaa.idlinea"
                    v-for="lineaa of lineas"
                  >
                    {{ lineaa.nombrelinea }}
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7 mt-3">
                <label
                  class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Talla
                </label>
                <select
                  @click="mostrar()"
                  v-model.number="talla"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                >
                  <option disabled value="">Seleccione una talla</option>
                  <option
                    v-bind:value="talla.idtalla"
                    :key="talla.idtalla"
                    v-for="talla of tallas"
                  >
                    {{ talla.nombretalla }}
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7 mt-3">
                <label
                  class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Color
                </label>

                <select
                  @click="mostrar()"
                  v-model.number="color"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="color.idcolor"
                    :key="color.idcolor"
                    v-for="color of colores"
                  >
                    <button>
                      {{ color.nombrecolor }}
                    </button>
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7 mt-3">
                <label
                  class="block uppercase tracking-wide mt-1 text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Categoria
                </label>

                <select
                  @click="mostrar()"
                  v-model.number="categoria"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="categoria.idcategoria"
                    :key="categoria.idcategoria"
                    v-for="categoria of categorias"
                  >
                    <button>
                      {{ categoria.nombrecategoria }}
                    </button>
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7 mt-3">
                <label
                  class="block uppercase mt-1 tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Genero
                </label>

                <select
                  v-model.number="genero"
                  @click="mostrar()"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="genero.idgenero"
                    :key="genero.idgenero"
                    v-for="genero of generos"
                  >
                    <button>
                      {{ genero.nombregenero }}
                    </button>
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7">
                <label
                  class="block uppercase mt-1 tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Nivel
                </label>

                <select
                  v-model.number="nivel"
                  @click="mostrar()"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="nivel.idnivel"
                    :key="nivel.idnivel"
                    v-for="nivel of niveles"
                  >
                    <button>
                      {{ nivel.nombrenivel }}
                    </button>
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7">
                <label
                  class="block uppercase mt-1 tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Target
                </label>
                <select
                  v-model.number="target"
                  @click="mostrar()"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="target.idtarget"
                    :key="target.idtarget"
                    v-for="target of targets"
                  >
                    <button>
                      {{ target.nombretarget }}
                    </button>
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7">
                <label
                  class="block uppercase mt-1 tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Grupo
                </label>

                <select
                  v-model.number="grupo"
                  @click="mostrar()"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="grupo.idgrupo"
                    :key="grupo.idgrupo"
                    v-for="grupo of grupos"
                  >
                    <button>
                      {{ grupo.nombregrupo }}
                    </button>
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7">
                <label
                  class="block uppercase mt-1 tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Marcas
                </label>

                <select
                  v-model.number="marca"
                  @click="mostrar()"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="marcaa.idmarca"
                    :key="marcaa.idmarca"
                    v-for="marcaa of marcas"
                  >
                    <button>
                      {{ marcaa.nombremarca }}
                    </button>
                  </option>
                </select>
              </div>
              <div class="col-span-1 mx-7">
                <label
                  class="block uppercase mt-1 tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
                  Caracteristica
                </label>

                <select
                  v-model.number="caracteristica"
                  @click="mostrar()"
                  class="shadow mt-2 rounded h-8 border-b-2 border-black w-44 flex"
                  id="grid-state"
                >
                  <option
                    v-bind:value="caracteristica.idcaracteristica"
                    :key="caracteristica.idcaracteristica"
                    v-for="caracteristica of caracteristicas"
                  >
                    <button>
                      {{ caracteristica.nombrecaracteristica }}
                    </button>
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="inline flex justify-center">
            <div class="col-span-1">
              <button
                @click="agregartable(), clean(), recargar()"
                type="button"
                class="w-full inline-flex justify-center mt-5 rounded-md border border-transparent shadow-sm px-2 py-1 bg-blue-600 text-base font-medium text-white hover:bg-blue-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
              >
                <a href="#"> Guardar </a>
              </button>
            </div>
          </div>
        </div>
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
//import axios from "axios";
export default {
  name: "modalProductos",
  data() {
    return {
      respuesta: null,
      verdad: false,
      // idlinea: "",
      nombrelinea: "",
      value: null,
      descripcion: "",
      codigoproducto: "",
      costoproducto: "",
      disponibleproducto: "",
      foto: "",
      caracteristica: [],
      idproducto: "",
      idtallaproducto: "",
      idtargetproducto: "",
      marca: "",
      ivaproducto: "",
      nombreproducto: "",
      referenciaproducto: "",
      reservaproducto: [],
      constoproducto: [],
      valorventa:'',

      color: "",
      categoria: [],
      genero: [],
      grupo: [],
      linea: [],
      talla: [],
      nivel: [],
      target: [],
    };
  },

  methods: {
    ...mapMutations("productos", [
      "agregartable",
      "cambio",
      "cargardatosproductos",
    ]),

    mostrar() {
      var datos = {
        codigoproducto: this.codigoproducto,
        costoproducto: this.costoproducto,
        disponibleproducto: this.disponibleproducto,
        foto: this.foto,
        idcaracteristica: this.caracteristica,
        idcategoriaproducto: this.categoria,
        idcolorproducto: this.color,
        idgeneroproducto: this.genero,
        idgrupoproducto: this.grupo,
        idlineaproducto: this.linea,
        idnivelproducto: this.nivel,
        idmarca: this.marca,
        //idproducto: this.producto,
        idtallaproducto: this.talla,
        idtargetproducto: this.target,
        // idusuario: this.idusuario,
        ivaproducto: this.ivaproducto,
        nombreproducto: this.nombreproducto,
        idreferencia: this.referenciaproducto,
        reservaproducto: this.reservaproducto,
        constoproducto: this.costoproducto,
        valorventa: this.valorventa
      };

      this.cambio(datos); 
    },
    async recargar() {
      setTimeout(() => {
        this.cargardatosproductos();
      }, 500);
    },
    clean() {
      this.descripcion = null;
      (this.codigoproducto = null),
        (this.costoproducto = null),
        (this.disponibleproducto = null),
        (this.foto = null),
        (this.caracteristica = null),
        (this.idproducto = null),
        (this.idtallaproducto = null),
        (this.idtargetproducto = null),
        (this.idusuario = ""),
        (this.ivaproducto = null),
        (this.nombreproducto = null),
        (this.referenciaproducto = null),
        (this.reservaproducto = null),
        (this.constoproducto = null),
        (this.color = null),
        (this.categoria = null),
        (this.genero = null),
        (this.grupo = null),
        (this.linea = null),
        (this.talla = null),
        (this.nivel = null),
        (this.target = null),
        (this.valor = false);
      (this.marca = null);
      (this.valorventa = null);
    },
  },
  computed: {
    ...mapState("productos", [
      "idmodal",
      "descripcionmodal",
      "scodigoproducto",
      "scostoproducto",
      "sdisponibleproducto",
      "sfoto",
      "sidcaracteristica",
      "sidcaracteristicaNavigation",
      "sidcategoriaproducto",
      "sidcategoriaproductoNavigation",
      "sidcolorproducto",
      "sidcolorproductoNavigation",
      "sidgeneroproducto",
      "sidgeneroproductoNavigation",
      "sidgrupoproducto",
      "sidgrupoproductoNavigation",
      "sidlineaproducto",
      "sidlineaproductoNavigation",
      "sidnivelproducto",
      "sidnivelproductoNavigation",
      "sidproducto",
      "sidtallaproducto",
      "sidtallaproductoNavigation",
      "sidtargetproducto",
      "sidtargetproductoNavigation",
      "sidusuario",
      "sidusuarioNavigation",
      "sivaproducto",
      "snombreproducto",
      "referencias",
      "sreservaproducto",
      "sconstoproducto",
      "tipodedocumento",
      "marcas",
      "targets",
      "tallas",
      'svalorventa',
      "niveles",
      "lineas",
      "grupos",
      "generos",
      "colores",
      "categorias",
      "caracteristicas",
      "colores",
    ]),
    ...mapState([
      "elemento",
      "id",
      //transportistas

      //"descripcion",
      "numero",
      // "idmodal",
      //"descripcionmodal",
      "banderamodal",
    ]),
  },
};
</script>
<style scoped >
.modal-contenido {
  background-color: rgb(255, 255, 255);
  width: auto;
  height: auto;

  margin: 15%;
  margin-top: 100px;
  position: relative;
}
.modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.1s;
}
#modalProductos:target {
  opacity: 1;
  pointer-events: auto;
}
</style>

